"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Adding separator between components.
 * @keywords Vertical divider, line
 */
var Separator =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Separator, _React$PureComponent);

  function Separator() {
    _classCallCheck(this, Separator);

    return _possibleConstructorReturn(this, _getPrototypeOf(Separator).apply(this, arguments));
  }

  _createClass(Separator, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          separator = _this$props.separator,
          spacing = _this$props.spacing,
          props = _objectWithoutProperties(_this$props, ["className", "separator", "spacing"]);

      var children = this.props.children;

      if (!children || _typeof(children) !== 'object' || !children.length) {
        return _react.default.createElement("span", null, children);
      }

      var items = []; // Only want to use truthy children.

      children = children.filter(function (child) {
        return !!child;
      });

      for (var i = 0; i < children.length - 1; i++) {
        items.push(_react.default.createElement("div", {
          key: "item".concat(i),
          className: "item"
        }, children[i])); // Add separator after each item (except for the last one).

        items.push(_react.default.cloneElement(separator, {
          key: "separator".concat(i),
          className: "separator ".concat(spacing, " item")
        }));
      } // Last child


      items.push(_react.default.createElement("div", {
        key: "item".concat(children.length - 1),
        className: "item"
      }, children[children.length - 1]));

      var clsPrfx = _ThemeManager.default.getVar('classPrefix');

      return _react.default.createElement("div", _extends({
        className: (0, _classnames.default)("".concat(clsPrfx, " ").concat(clsPrfx, "-separator"), className)
      }, props), items);
    }
  }]);

  return Separator;
}(_react.default.PureComponent);

exports.default = Separator;
Separator.defaultProps = {
  spacing: 'spacing-15px'
};
Separator.propTypes = {
  /**
   * Additional classname
   */
  className: _propTypes.default.string,

  /**
   * Two or more children to add a separator in between.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * The separator element.
   * Example:
   * <VerticalSeparator/>, or any Icons
   */
  separator: _propTypes.default.node.isRequired,

  /**
   * Spacing between the separator and the items adjacent to it.
   * 15px is generally used for small separators (default)
   * 20px is generally used for large separators (like separating buttons)
   */
  spacing: _propTypes.default.oneOf(['spacing-10px', 'spacing-15px', 'spacing-20px'])
};